import { render, staticRenderFns } from "./rollingCard.vue?vue&type=template&id=d25a4112&scoped=true"
import script from "./rollingCard.vue?vue&type=script&lang=js"
export * from "./rollingCard.vue?vue&type=script&lang=js"
import style0 from "./rollingCard.vue?vue&type=style&index=0&id=d25a4112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25a4112",
  null
  
)

export default component.exports